export default "__VITE_ASSET__DeehmTQ$__"